import { Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
export default function BulkAppointmentBookingBreadCrumbs() {
  const navigate = useNavigate(); 

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb" sx={{ color: "gray" }}>
      <Link
          underline="hover"
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
          }}
          color="primary"
          onClick={() => navigate("/")}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Home
        </Link>
        <Link
          underline="hover"
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
          }}
          color="primary"
         
          onClick={() =>
            navigate("/bulk-appointment")
          }
        >
          
          Bulk Appointment
        </Link>

        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
          }}
          color={"inherit"}
        >
          Bulk Appointment List
        </Typography>
      </Breadcrumbs>
    </div>
  );
}